import React, {useState, useRef, useEffect} from 'react';
import CustomTable from '../../../components/customTable/CustomTable';
import {t, getLanguage} from 'react-switch-lang';
import Toast from '../../../components/toast/Toast';
import Prompt from '../../../components/prompt/prompt';
import SearchBox from '../../../components/searchBox/SearchBox';
import AddIcon from '../Metodologies/plus.png';
import '../Metodologies/Metodologies.scss';
import {validNameandNumberEngMneRegex} from '../../../utils/const';
import Swal from "sweetalert2";
import {getAllLossReasons} from "../../../services/riskExpensesService";
import {updateLossReason} from "../../../services/riskExpensesService";
import {createLossReason} from "../../../services/riskExpensesService";
import {deleteLossReason} from "../../../services/riskExpensesService";
const Codebook = () => {
    const [riskExpense, setRiskExpense] = useState([]);
    const [query, setQuery] = useState();
    useEffect(() => {
        const fetchData = async () => {
            try {
                const {data} = await getAllLossReasons();
                setRiskExpense(data);
            } catch (err) {}
        };
        fetchData();
    }, []);

    const columns = [
        {
            dataIndex: 'name',
            title: t('metodologies.name'),
            editable: true,
            placeholder: t('metodologies.placeholder.name'),
            rules: [
              {
                required: true,
                whitespace: true,
                message: t('message.fieldRequired'),
              },
                {
                    pattern: validNameandNumberEngMneRegex,
                    message: t('message.fieldNotValid'),
                },
              {
                min: 3,
                transform: (value) => value ? value.trim() : '',
                message: t('message.min', {min: 3}),
              },
              {
                max: 50,
                transform: (value) => value ? value.trim() : '',
                message: t('message.max', {max: 50}),
              },
            ],
        },
        {
            dataIndex: 'nameEn',
            title: t('metodologies.nameEn'),
            editable: true,
            placeholder: t('metodologies.placeholder.nameEn'),
            rules: [
              {
                required: true,
                whitespace: true,
                message: t('message.fieldRequired'),
              },
                {
                    pattern: validNameandNumberEngMneRegex,
                    message: t('message.fieldNotValid'),
                },
              {
                min: 3,
                transform: (value) => value ? value.trim() : '',
                message: t('message.min', {min: 3}),
              },
              {
                max: 50,
                transform: (value) => value ? value.trim() : '',
                message: t('message.max', {max: 50}),
              }
            ],
        },
        {
            dataIndex: 'code',
            title: t('codebook.code'),
            editable: true,
            placeholder: t('codebook.codePlaceholder'),
            rules: [
                {required: true, message: t('message.fieldRequired')},
                {
                    pattern: validNameandNumberEngMneRegex,
                    message: t('message.fieldNotValid'),
                },
                {min: 1, message: t('message.min', {min: 1})},
                {max: 10, message: t('message.max', {max: 10})},
                { whitespace: true,
                    message: t('message.fieldNotValid'),
                },
            ],
        },
    ];

    const onUpdate = async (data, editingRecord, form) => {
        data.id = editingRecord.id;
        data.nameEn = data.nameEn.trim();
        data.name = data.name.trim();
        data.code = data.code.trim();
        try {
            const response = await updateLossReason(data,data.id);
            if (response.status === 200) {
                Toast.fire({
                    title: t('codebook.successfullyAddedCodeBook', {
                        entity: t('codebook.codebook'),
                    }),
                    icon: 'success',
                });
            }
            return response;
        } catch (err) {
            if (err.response.data.code === 'loss-reason-code-already-exists') {
                form.setFields([
                    {
                        name: 'code',
                        errors: [t('message.codebookExists')],
                    },
                ]);
            }
            if (err.response.data.detail === 'name_en') {
                form.setFields([
                    {
                        name: 'nameEn',
                        errors: [t('message.codebookExists')],
                    },
                ]);
            }
        }
    };
    const onCreate = async (data, form) => {
        data.nameEn = data.nameEn.trim();
        data.name = data.name.trim();
        data.code = data.code.trim()
        try {
            const response = await createLossReason(data);
            if (response.status === 200) {
                Toast.fire({
                       title: t('codebook.successfullyAddedCodeBook', {
                        entity: t('codebook.codebook'),
                    }),
                    icon: 'success',
                });
            }
            return response;
        } catch (err) {
            if (err.response.data.code === 'loss-reason-code-already-exists') {
                form.setFields([
                    {
                        name: 'code',
                        errors: [t('message.codebookExists')],
                    },
                ]);
            }
        }
    };
    const onDelete = async (record) => {
        return new Promise((resolve, reject) => {
            Prompt.fire({
                title: t('codebook.delete'),
                text: t('question.delete', {entity: getLanguage() === "eng" ? record.nameEn : record.name}),
                confirmButtonText: t('common.delete').toUpperCase(),
                cancelButtonText: t('common.cancel').toUpperCase(),
                preConfirm: async () => {
                    try {
                        const response = await deleteLossReason(record.id);
                        if (response.status === 204) {
                            Toast.fire({
                                title: t('codebook.deleteSuccess', {
                                    entity: t('codebook.codebook'),
                                }),
                                icon: 'success',
                            });
                            resolve(response);
                        } else {
                            reject(response);
                        }
                    } catch (err) {
                        Swal.fire({
                            text: `${t('message.errorDeleteLossReason')}`,
                            icon: 'error',
                            confirmButtonText: 'OK',
                        });
                    }
                },
            });
        });
    };
    const addButton = useRef();
    return (
        <div className="users administration-template">
            <div className="w-100 d-flex justify-content-between mb-4">
                <div className="search-field">
                    <SearchBox
                        placeholder={t('codebook.search')}
                        setQuery={setQuery}
                    />
                </div>
                <div className="button-add">
                    <button className="btn btn-primary" ref={addButton}>
                        <img src={AddIcon} alt="" />
                        <p>{t('codebook.addCodebook')}</p>
                    </button>
                </div>
            </div>
            <CustomTable
                api="/loss-reasons"
                columns={columns}
                sort={getLanguage() === "eng" ? "nameEn" : "name"}
                query={query}
                queryParamName={getLanguage() === "eng" ? "nameEn.contains" : "name.contains"}
                methods={{onUpdate, onDelete, onCreate}}
                addButtonRef={addButton}
            />
        </div>
    );
};

export default Codebook;
